// send-demands-modal.component.ts
import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import "../../../assets/semantic/semantic.min.js";
import { DemandService } from "../../_services/demand.service";
import { ToastService } from "../../_services/toast.service";
declare var jQuery: any;


@Component({
  selector: 'app-send-demands-modal',
  templateUrl: './send-demands-modal.component.html',
  styleUrls: ['./send-demands-modal.component.css']
})
  
export class SendDemandsModalComponent implements OnInit {

  @Output() refresh = new EventEmitter<void>();
  offers: any[] = [];
  selectedDemands: any[] = [];
  offersByDemand: any[] = [];
  favoriteOffersByDemand: any[] = [];
  historyPlannings: any[] = [];

  constructor(private http: HttpClient, private demandeService: DemandService, private toast: ToastService) {}

  ngOnInit(): void {}
  
  openModal(selectedDemands: any[]): void {
    this.selectedDemands = selectedDemands;
    jQuery('#sendDemandsModal').modal('show');
    
    this.fetchOffers(this.selectedDemands);
    jQuery('.menu .item').tab();
  }

  closeModal(): void {
    jQuery('#sendDemandsModal').modal('hide');
  }

  fetchOffers(demands): void {
    this.offersByDemand = [];
    this.favoriteOffersByDemand = [];
    this.historyPlannings = [];
    
    // Récupérer les transporteurs favoris sans tenir compte de la demande
    this.demandeService.getFavoriteTransporters().subscribe(favoriteResponse => {
      if (favoriteResponse.length > 0) {
        this.favoriteOffersByDemand.push(...favoriteResponse);
        //console.log('favoriteOffersByDemand', this.favoriteOffersByDemand);
      }
    });
    
    demands.forEach(demand => {
      
      this.demandeService.getMatchingOffers(demand.id) //on recupere les offres et leur transporteurs pour les demandes selectionnées
        .subscribe(response => {
          if (response.offers) {
            const offers = response.offers.map(offer => ({ ...offer, selected: false }));

            this.offersByDemand.push({
              demand: demand,
              offers: offers
            });

            //onglet favoris
            /* const favoriteOffers = offers.filter(offer => offer.seller.is_favorite);
             if (favoriteOffers.length > 0) {
               this.favoriteOffersByDemand.push({
                 demand: demand,
                 offers: favoriteOffers
               });
             }*/
          }
          //console.log('offersByDemand', this.offersByDemand);
          //console.log('favoriteOffersByDemand', this.favoriteOffersByDemand);*/
        });
    
      //on  va chercher dans les plannings ce qui a deja ete fait sur les memes villes, on recupere les id des transporteurs.
      this.demandeService.getPlannedDemands(demand.departure_id, demand.arrival_id).subscribe(response => {
        //console.log('response', response);
        if (Array.isArray(response)) {
          this.historyPlannings.push(...response);
        }

        //console.log('historyPlannings', this.historyPlannings)
      })
    })

    //

  }
  
  get isSendDisabled(): boolean {

    //favoriteOffersByDemand
    //return !this.offersByDemand.some(group => group.offers.some(offer => offer.selected));
    return false
  }

  sendDemands(): void {

    
    const selectedOffersByDemand = this.offersByDemand
      .map(group => ({
        demandId: group.demand.id,
        selectedOffers: group.offers.filter(o => o.selected).map(o => o.id)
      }))
      

    if (selectedOffersByDemand.length === 0) {
      alert('Veuillez sélectionner au moins un transporteur.');
      return;
    }

    /*const favoriteTransporters = this.favoriteOffersByDemand.map(group => ({
      demandId: group.demand.id,
      selectedOffers: group.offers.filter(o => o.selected).map(o => o.id)
    }));*/

    //ID des transporteurs favoris selectionnés
    const favoriteTransporters = this.favoriteOffersByDemand
      .filter(transporter => transporter.selected)
      .map(transporter => transporter.id);


    const allOffersByDemand = selectedOffersByDemand.map(selected => {
      //const favorite = favoriteTransporters.find(fav => fav.demandId === selected.demandId);
      //console.log('selected', selected.selectedOffers);
      return {
        demandId: selected.demandId,
        selectedOffers: [...selected.selectedOffers ] 
        //selectedOffers: [...selected.selectedOffers, ...(favorite ? favorite.selectedOffers : [])] 
      };
    });
    
    const demands = allOffersByDemand.map(group => group.demandId);
    const offers = allOffersByDemand.reduce((acc, group) => acc.concat(group.selectedOffers), []);

    const planningTransporters = this.historyPlannings
      .filter(planning => planning.selected)
      .map(planning => planning.transporter.id); 
     
    this.demandeService.sendSelectedDemandsToSelectedTransporters(demands, offers, favoriteTransporters, planningTransporters).subscribe(() => {
      this.toast.success("Email Envoyés au transporteurs", false, "Mail");
      this.refresh.emit();
      this.closeModal();
    });

    /*
    this.http.post('/api/send-transport-requests', requestData).subscribe(
      () => {
        alert('Demandes envoyées avec succès');
        this.refresh.emit();
        this.closeModal();
      },
      (error) => {
        console.error('Erreur lors de l\'envoi des demandes', error);
      }
    );*/
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/send-demands-modal/send-demands-modal.component.ts